<script setup>
import { computed, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useRouter } from 'vue-router';
import { useUiStore } from '@/store/uiStore'
import Breadcrumbs from "../Breadcrumbs.vue";
import { useAuthStore } from "@/modules/auth/stores/authStore";
import api from "@/api/axios";

const facturasPendientes = ref([]);

onMounted(async () => {
  try {
    const resFacturas = await api.post("facturas/facturas-vencidas-sin-pagos");
    // Asegurar que siempre sea un array
    facturasPendientes.value = Array.isArray(resFacturas.data.data) ? resFacturas.data.data : [];
  } catch (error) {
    console.error("Error cargando facturas:", error);
    facturasPendientes.value = [];
  }
});
const showMenu = ref(false);
const ui = useUiStore()
const isRTL = computed(() => ui.isRTL);

const route = useRoute();
const router = useRouter();

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});

const minimizeSidebar = () => ui.sidebarMinimize();
const toggleConfigurator = () => ui.toggleConfigurator();

// const closeMenu = () => {
//   setTimeout(() => {
//     showMenu.value = false;
//   }, 100);
// };

const authStore = useAuthStore();

const cerrarSesion = async () => {
  await authStore.logout();
  router.push('/signin');
};

const formatCurrency = (value) => {
  if (!value || isNaN(value)) return '$0'
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP'
  }).format(value)
}

</script>
<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    :class="isRTL ? 'top-0 position-sticky z-index-sticky' : ''" v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" :class="isRTL ? 'px-0' : 'me-sm-4'"
        id="navbar">
        <div class="pe-md-3 d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
          <div class="input-group">
            <span class="input-group-text text-body">
              <i class="fas fa-search" aria-hidden="true"></i>
            </span>
            <input type="text" class="form-control" :placeholder="isRTL ? 'أكتب هنا...' : 'Type here...'" />
          </div>
        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" @click="minimizeSidebar" class="p-0 nav-link text-white" id="iconNavbarSidenav">
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>
          <li class="px-3 nav-item d-flex align-items-center">
            <a class="p-0 nav-link text-white" @click="toggleConfigurator" >
              <i class="cursor-pointer fa fa-cog fixed-plugin-button-nav"></i>
            </a>
          </li>
          <li class="nav-item dropdown d-flex align-items-center" :class="isRTL ? 'ps-2' : 'pe-2'">
            <a href="#" class="p-0 nav-link text-white" :class="[showMenu ? 'show' : '']" id="dropdownMenuButton"
              data-bs-toggle="dropdown" aria-expanded="false" @click="showMenu = !showMenu" >
              <i class="cursor-pointer fa fa-bell"></i>
              <span :class="facturasPendientes.length < 1 ? 'd-none' : ''"
                class="badge badge-xs badge-circle badge-floating badge-danger border-white">{{
                  facturasPendientes.length }}</span>
            </a>
            <ul class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4" :class="showMenu ? 'show' : ''"
              aria-labelledby="dropdownMenuButton">
              <template v-if="facturasPendientes.length > 0">
                <!-- <tr v-for="(item, index) in validItems" :key="item?.fact_id || `factura-${index}`"> -->

                <li v-for="factura in facturasPendientes" :key="factura.fact_id" class="mb-2">
                  <ul class="dropdown-item border-radius-md" href="#">
                    <div class="py-1 d-flex">
                      <div class="my-auto">
                        <img src="@/assets/img/alerta-factura.jpg" class="avatar avatar-sm me-1" alt="user image" />
                        <!-- <img src="url(images/fondo-empresa-4-1.png)" class="avatar avatar-sm me-3" alt="user image" /> -->
                        <!-- <img src="@/assets/img/team-2.jpg" class="avatar avatar-sm me-3" alt="user image" /> -->
                      </div>
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-1 text-sm font-weight-normal">
                          <span class="font-weight-bold">Factura "{{ factura.fact_numero }}" Pendiente: </span>{{
                            factura.proveedor.prov_nombre }}
                        </h6>
                        <p class="mb-0 text-xs text-secondary">
                          <i class="fa fa-file-invoice-dollar me-1"
                            :class="factura.fact_fecha_vencimiento < new Date().toISOString().split('T')[0] ? 'text-danger' : 'text-success'"></i>Valor
                          Pendiente:
                          {{ formatCurrency(factura.fact_saldo) }}
                        </p>
                        <p class="mb-0 text-xs text-secondary">
                          <i class="fa fa-clock me-1"
                            :class="factura.fact_fecha_vencimiento < new Date().toISOString().split('T')[0] ? 'text-danger' : 'text-success'"></i>Vence:
                          {{ factura.fact_fecha_vencimiento }}
                        </p>
                      </div>
                    </div>
                  </ul>
                </li>
              </template>
              <!-- <li class="mb-2">
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="my-auto">
                      <img src="@/assets/img/small-logos/logo-spotify.svg"
                        class="avatar avatar-sm bg-gradient-dark me-3" alt="logo spotify" />
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold">New album</span> by
                        Travis Scott
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        1 day
                      </p>
                    </div>
                  </div>
                </a>
              </li>
              <li>
                <a class="dropdown-item border-radius-md" href="javascript:;">
                  <div class="py-1 d-flex">
                    <div class="my-auto avatar avatar-sm bg-gradient-secondary me-3">
                      <svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <title>credit-card</title>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero">
                            <g transform="translate(1716.000000, 291.000000)">
                              <g transform="translate(453.000000, 454.000000)">
                                <path class="color-background"
                                  d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z"
                                  opacity="0.593633743" />
                                <path class="color-background"
                                  d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z" />
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        Payment successfully completed
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <i class="fa fa-clock me-1"></i>
                        2 days
                      </p>
                    </div>
                  </div>
                </a>
              </li> -->
            </ul>
          </li>
          <li class="nav-item">
            <a href="#" @click="cerrarSesion"
              class="nav-link d-flex align-items-center gap-2 text-white px-2 py-1 rounded"
              style="transition: background-color 0.2s;" title="Cerrar sesión">
              <font-awesome-icon icon="fas fa-door-open" class="fs-5" :class="isRTL ? 'ms-sm-2' : 'me-sm-2'" />
            </a>

          </li>

        </ul>
      </div>
    </div>
  </nav>
</template>
